/* ==========================================================================
  Ajax
	-----------------------------------------------
	- open class for elements = .js-ajax-open
	- target ajax item(s) = '#ajaxTarget'
	- scroll on .ajax (overflow: hidden)
	- call loadIn on #ajaxContainer
	
	- 	$(‘#ajaxContainer’).rhLoadIn({
       		ajax:true
		})
    
    - 	$('.parallax').rhParallax({
			parallaxRatio:1.4,
			ajax:true,
			selector:'#ajaxContainer'
		});


  ========================================================================== */

var $ajaxOverlay2 = $("#js-ajax-overlay"),
    $closeAjaxButton2 = $("#closeAjaxButton"),
    $ajaxDestination = $("#ajaxDestination"),
    ajaxOpen2 = false,
    originalHref2,
    ajaxHref2,
    $loader2 = $("#loader");

//ajax for cards
$(document).on("click", ".js-ajax-open", function (e) {
    e.preventDefault();

    ajaxHref2 = $(this).attr("href");

    if (ajaxOpen2 == false) {
        ajaxOpen2 = true;

        originalHref2 = window.location.href;

        $body.addClass("stop-scrolling");

        TweenMax.to($ajaxOverlay2, 0.4, {
            autoAlpha: 1,
            top: "0",
            ease: Power4.easeInOut,
            onComplete: openAjax2,
            onCompleteParams: [ajaxHref2]
        });

        TweenMax.to($closeAjaxButton2, 0.3, {
            autoAlpha: 1,
            ease: Power4.easeInOut,
            delay: 0.5
        });
    }

    history.pushState({}, "", ajaxHref2);
});

//close ajax
$closeAjaxButton2.on("click", function (e) {
    e.preventDefault();

    ajaxOpen2 = false;

    $body.removeClass("stop-scrolling");

    TweenMax.to($ajaxOverlay2, 0.4, {
        autoAlpha: 0,
        top: "100%",
        ease: Power4.easeInOut,
        onComplete: emptyAjax2
    });

    TweenMax.to($closeAjaxButton2, 0.4, { autoAlpha: 0 });
    history.pushState({}, "", originalHref2);
});

//history pop state
window.onpopstate = function () {
    $body.removeClass("stop-scrolling");

    if (ajaxOpen2 == true) {
        ajaxOpen2 = false;

        TweenMax.to($ajaxOverlay2, 0.4, {
            autoAlpha: 0,
            top: "100%",
            ease: Power4.easeInOut,
            onComplete: emptyAjax2
        });

        TweenMax.to($closeAjaxButton2, 0.4, { autoAlpha: 0 });

        history.pushState({}, "", originalHref2);
    }
};

function openAjax2(ajaxHref2) {
    $ajaxDestination.load(ajaxHref2 + " #ajaxSource", function () {
        $loader2.fadeOut();

        $ajaxDestination.imagesLoaded(function () {
            //refire any functions here

            // lazyLoad(threshold, "#ajaxOverlay2");

            flickity404 = document.querySelector(".js-404-carousel");

            if (flickity404) {
                flkty = new Flickity(flickity404, {
                    cellAlign: "left",
                    contain: true,
                    draggable: true,
                    wrapAround: true,
                    prevNextButtons: false,
                    pageDots: false,
                    imagesLoaded: true,
                    autoPlay: true,
                    fade: true
                });
            }
        });
    });
}

function emptyAjax2() {
    $ajaxDestination.empty();
}
